import { Suspense } from "react";

import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom"; // styles

import "@atlaskit/css-reset";
import "./assets/css/style.css";
import "./assets/css/combined.css";
import "./assets/css/webrtc.css"; // components
import App from "./App";
import AuthProvider from "./contexts/authContext";
import reportWebVitals from "./reportWebVitals";

const LoadingFallback = () => <div>Loading...</div>;

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <Suspense fallback={<LoadingFallback />}>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </Suspense>,
  document.getElementById("root"),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

module.hot.accept();
